import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { SystemClassifierDto } from '../schema';
import { SystemClassifierUrl } from './SystemClassifierUrl';
import { SystemClassifierSchema } from '../schema/SystemClassifierSchema';

const getSystemClassifier = ({ id }: { id: number }) =>
  apiClient
    .get<SystemClassifierDto>(
      expand(SystemClassifierUrl.SYSTEM_CLASSIFIER, { id })
    )
    .then((response) => SystemClassifierSchema.parse(response.data));

export const useSystemClassifierQuery = createApiQueryHook(
  ['systemClassifier'],
  getSystemClassifier
);
